export default function getFields(vm) {
  const fields = [
    {
      key: 'geofence',
      label: 'report.fields.geolocation',
      header: 'geofence',
      filter: true,
      width: 20,
      headerRowspan: 2,
      isLocked: true,
    },
    {
      key: 'licensePlate',
      label: 'report.fields.licensePlate',
      header: 'licensePlate',
      filter: true,
      width: 20,
      headerRowspan: 2,
      isLocked: true,
    },
    {
      key: 'tripMileage',
      label: 'report.fields.tripMileageKm',
      header: 'tripMileage',
      filter: true,
      width: 20,
      headerRowspan: 2,
      isLocked: true,
    },
    {
      key: 'ritageMileage',
      label: 'report.fields.ritageMileageKm',
      header: 'ritageMileage',
      filter: true,
      width: 20,
      headerRowspan: 2,
      isLocked: true,
    },
    {
      key: 'tripDuration',
      label: 'report.fields.tripDurationIjp',
      header: 'tripDuration',
      filter: true,
      width: 20,
      headerRowspan: 2,
      isLocked: true,
    },
    {
      key: 'ritageDuration',
      label: 'report.fields.ritageDuration',
      header: 'ritageDuration',
      filter: true,
      width: 20,
      headerRowspan: 2,
      isLocked: true,
    },
    {
      key: 'ritageMileageZone',
      label: 'report.fields.ritageMileageZone',
      header: 'ritageMileageZone',
      filter: false,
      isLocked: true,
      width: 30,
      children: [
        {
          key: 'ritageMileageZoneOne',
          label: 'report.fields.zoneOne',
          header: 'ritageMileageZoneOne',
          headerColspan: 1,
          childOfIndex: 0,
          isTopHead: 1,
          isLocked: true,
        },
        {
          key: 'ritageMileageZoneTwo',
          label: 'report.fields.zoneTwo',
          header: 'ritageMileageZoneTwo',
          headerColspan: 1,
          childOfIndex: 0,
          isTopHead: 0,
          isLocked: true,
        },
        {
          key: 'ritageMileageZoneThree',
          label: 'report.fields.zoneThree',
          header: 'ritageMileageZoneThree',
          headerColspan: 1,
          childOfIndex: 0,
          isTopHead: 0,
          isLocked: true,
        },
        {
          key: 'ritageMileageZoneFour',
          label: 'report.fields.zoneFour',
          header: 'ritageMileageZoneFour',
          headerColspan: 1,
          childOfIndex: 0,
          isTopHead: 0,
          isLocked: true,
        },
        {
          key: 'ritageMileageZoneFive',
          label: 'report.fields.zoneFive',
          header: 'ritageMileageZoneFive',
          headerColspan: 1,
          childOfIndex: 0,
          isTopHead: 0,
          isLocked: true,
        },
        {
          key: 'ritageMileageZoneSix',
          label: 'report.fields.zoneSix',
          header: 'ritageMileageZoneSix',
          headerColspan: 1,
          childOfIndex: 0,
          isTopHead: 0,
          isLocked: true,
        },
        {
          key: 'ritageMileageZoneTotal',
          label: 'report.fields.total',
          header: 'ritageMileageZoneTotal',
          headerColspan: 1,
          childOfIndex: 0,
          isTopHead: 0,
          isLocked: true,
        },
      ],
      headerColspan: 7,
    },
    {
      key: 'fuelAdded',
      label: 'report.fields.fuelAdded',
      header: 'fuelAdded',
      filter: true,
      width: 20,
      headerRowspan: 2,
      isLocked: true,
    },
    {
      key: 'fuelRatioPerKm',
      label: 'report.fields.fuelRatioPerKm',
      header: 'fuelRatioPerKm',
      filter: true,
      width: 20,
      headerRowspan: 2,
      isLocked: true,
    },
    {
      key: 'fuelRatioPerHour',
      label: 'report.fields.fuelRatioPerHour',
      header: 'fuelRatioPerHour',
      filter: true,
      width: 20,
      headerRowspan: 2,
      isLocked: true,
    },
    {
      key: 'ritageDurationZone',
      label: 'report.fields.ritageDurationZone',
      header: 'ritageDurationZone',
      filter: false,
      isLocked: true,
      width: 30,
      children: [
        {
          key: 'ritageDurationZoneOne',
          label: 'report.fields.zoneOne',
          header: 'ritageDurationZoneOne',
          filter: false,
          isLocked: true,
          width: 20,
          childOfIndex: 1,
          isTopHead: 1,
          headerColspan: 1,
        },
        {
          key: 'ritageDurationZoneTwo',
          label: 'report.fields.zoneTwo',
          header: 'ritageDurationZoneTwo',
          filter: false,
          isLocked: true,
          width: 30,
          childOfIndex: 1,
          isTopHead: 0,
          headerColspan: 1,
        },
        {
          key: 'ritageDurationZoneThree',
          label: 'report.fields.zoneThree',
          header: 'ritageDurationZoneThree',
          filter: false,
          isLocked: true,
          width: 30,
          childOfIndex: 1,
          isTopHead: 0,
          headerColspan: 1,
        },
        {
          key: 'ritageDurationZoneFour',
          label: 'report.fields.zoneFour',
          header: 'ritageDurationZoneFour',
          filter: false,
          isLocked: true,
          width: 30,
          childOfIndex: 1,
          isTopHead: 0,
          headerColspan: 1,
        },
        {
          key: 'ritageDurationZoneFive',
          label: 'report.fields.zoneFive',
          header: 'ritageDurationZoneFive',
          filter: false,
          isLocked: true,
          width: 30,
          childOfIndex: 1,
          isTopHead: 0,
          headerColspan: 1,
        },
        {
          key: 'ritageDurationZoneSix',
          label: 'report.fields.zoneSix',
          header: 'ritageDurationZoneSix',
          filter: false,
          isLocked: true,
          width: 30,
          childOfIndex: 1,
          isTopHead: 0,
          headerColspan: 1,
        },
        {
          key: 'ritageDurationZoneSeven',
          label: 'report.fields.zoneSeven',
          header: 'ritageDurationZoneSeven',
          filter: false,
          isLocked: true,
          width: 30,
          childOfIndex: 1,
          isTopHead: 0,
          headerColspan: 1,
        },
        {
          key: 'ritageDurationZoneTotal',
          label: 'report.fields.total',
          header: 'ritageDurationZoneTotal',
          filter: false,
          isLocked: true,
          width: 30,
          childOfIndex: 1,
          isTopHead: 0,
          headerColspan: 1,
        },
      ],
      headerColspan: 8,
    },
    {
      key: 'safety',
      label: 'report.fields.safety',
      header: 'safety',
      filter: false,
      isLocked: true,
      width: 30,
      children: [
        {
          key: 'overSpeed',
          label: 'report.fields.overSpeed',
          header: 'overSpeed',
          filter: false,
          isLocked: true,
          width: 20,
          childOfIndex: 2,
          isTopHead: 1,
          headerColspan: 1,
        },
        {
          key: 'totalOverSpeed',
          label: 'report.fields.totalOverSpeed',
          header: 'totalOverSpeed',
          filter: false,
          isLocked: true,
          width: 30,
          childOfIndex: 2,
          isTopHead: 0,
          headerColspan: 1,
        },
        {
          key: 'harshBreaking',
          label: 'report.fields.harshBreaking',
          header: 'harshBreaking',
          filter: false,
          isLocked: true,
          width: 30,
          childOfIndex: 2,
          isTopHead: 0,
          headerColspan: 1,
        },
        {
          key: 'harshAcceleration',
          label: 'report.fields.harshAcceleration',
          header: 'harshAcceleration',
          filter: false,
          isLocked: true,
          width: 30,
          childOfIndex: 2,
          isTopHead: 0,
          headerColspan: 1,
        },
        {
          key: 'harshCornering',
          label: 'report.fields.sharpTurn',
          header: 'harshCornering',
          filter: false,
          isLocked: true,
          width: 30,
          childOfIndex: 2,
          isTopHead: 0,
          headerColspan: 1,
        },
      ],
      headerColspan: 5,
    },
  ]

  fields.forEach((item) => {
    if (Object.prototype.hasOwnProperty.call(item, 'children')) {
      item.children.forEach((child) => {
        child.label = vm.$t(child.label)
      })
    }
    item.label = vm.$t(item.label)
  })

  return fields
}
